<template>
  <div class="lobby-container" v-if="localParticipant">
    <div class="join-container">
      <h1 class="getting-ready__p">Getting ready for a meeting...</h1>
      <button id="join-button" @click="joinMeeting()">Join now</button>
    </div>
    <div class="participant-container">
      <participant-tile :participant="localParticipant" />
    </div>

    <!-- <div style="background: pink;">
      <h2>Unblock your mic/camera</h2>
      <template v-if="showCameraOrMicBlockedModal">
        <img height="48" src="/unblock_audio_video.png" alt=""/>
        <ol>
          <li>Click the camera icon</li>
          <li>Select “Always Allow”, click Done</li>
          <li>Refresh the page</li>
        </ol>
        <button @click="showCameraOrMicBlockedModal = false">Ok</button>
      </template>
      <template v-else>
        <button @click="showCameraOrMicBlockedModal = true">Learn more</button>
      </template>
    </div> -->
    <!-- <div>
      <div>
        <button @click="$store.dispatch('localVideo', !localParticipant.video)">
          {{ localParticipant.video ? "Turn camera off" : "Turn camera on" }}
        </button>
        <button @click="$store.dispatch('localAudio', !localParticipant.audio)">
          {{ localParticipant.audio ? "Turn audio off" : "Turn audio on" }}
        </button>
      </div>
      <SelectDevices/>
    </div> -->
    <!-- <button
      style="border: solid blue"
      @click="() => $store.dispatch('joinMeeting')"
    >
      Join Meeting
    </button> -->
  </div>
</template>

<script>
import SelectDevices from "./SelectDevices.vue";
import ParticipantTile from "./ParticipantTile";
import LobbyActions from "./LobbyActions";
import ResponsiveGrid from "../ResponsiveGrid";

export default {
  name: "Lobby",
  components: { ParticipantTile, SelectDevices, LobbyActions, ResponsiveGrid },
  data() {
    return {
      showCameraOrMicBlockedModal: true,
    };
  },
  computed: {
    cameraOrMicBlocked() {
      return this.$store.state.meeting.cameraOrMicBlocked;
    },
    localParticipant() {
      return this.$store.getters.localParticipant;
    },
  },
  methods: {
    joinMeeting() {
      this.$store.dispatch("joinMeeting");
    },
  },
};
</script>

<style scoped lang="scss">
.lobby-container {
  height: 100%;
  padding: 0px 1rem;

  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: 768px) {
    display: flex;
  }
}

.join-container {
  width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  @media screen and (min-width: 768px) {
    flex: 1;
  }

  @media screen and (min-width: 1280px) {
    padding-right: 1rem;
  }
}

.participant-container {
  padding: 0 !important;

  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;

  height: auto;

  @media screen and (min-width: 768px) {
    margin-top: 0px;
    flex: 1;
    height: auto;
    width: auto;
  }
}

.getting-ready__p {
  font-family: "Playfair Display", sans-serif;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 400;
  text-align: center;

  @media screen and (min-width: 1280px) {
    font-size: 36px;
    line-height: 48px;
  }
}

#join-button {
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #fff;
  background-color: #fc5a12;
  border-radius: 16px;

  width: 100%;
  max-width: 288px;
  height: 64px;

  margin-top: 2rem;

  @media screen and (min-width: 768px) {
    max-width: 152px;
  }

  @media screen and (min-width: 1280px) {
    margin-top: 4rem;
  }
}
</style>
